import { Radio } from 'lucide-react';

// Presentational Live toggle ([6.7]). The owning surface holds the `live` state
// and drives useAnalyticsLiveStream; this just renders the control.
const AnalyticsLiveToggle = ({ live, onToggle }) => (
  <button
    type="button"
    className={'analytics-live-toggle' + (live ? ' live' : '')}
    onClick={() => onToggle(!live)}
    aria-pressed={live}
    title={live ? 'Live updates on (click to pause)' : 'Live updates off (click to start)'}
  >
    <span className="analytics-live-dot" />
    <Radio size={14} />
    <span>{live ? 'Live' : 'Go live'}</span>
  </button>
);

export default AnalyticsLiveToggle;
